var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardsIcon = function SvgCardsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.734 4.528h5.037v5.037H3.734zm-1 0a1 1 0 0 1 1-1h5.037a1 1 0 0 1 1 1v5.037a1 1 0 0 1-1 1H3.734a1 1 0 0 1-1-1zm1 8.796h5.037v5.037H3.734zm-1 0a1 1 0 0 1 1-1h5.037a1 1 0 0 1 1 1v5.037a1 1 0 0 1-1 1H3.734a1 1 0 0 1-1-1zm14.833-8.796H12.53v5.037h5.038zm-5.037-1a1 1 0 0 0-1 1v5.037a1 1 0 0 0 1 1h5.038a1 1 0 0 0 1-1V4.528a1 1 0 0 0-1-1zm0 9.796h5.038v5.037H12.53zm-1 0a1 1 0 0 1 1-1h5.038a1 1 0 0 1 1 1v5.037a1 1 0 0 1-1 1H12.53a1 1 0 0 1-1-1z",
    clipRule: "evenodd"
  })));
};
export default SvgCardsIcon;